import {
    types
} from './types';
import firebase from '../firebase/firebase';
import {
    getServiceRatingForUser,
    getServiceReviewForUser
} from './service-actions';

const db = firebase.database();

const verifyAndGetBookingData = (allUserBookingsSnap, queryCode) => {
    let consultCodeVerified = false;
    let bookingValue = null;
    // console.log('VERIFYING CODE AND HASH');

    allUserBookingsSnap.forEach((booking) => {
        const isBookingConfirmed = booking.val() && booking.val().confirmationData;
        if (isBookingConfirmed) {
            const {
                hash,
                code
            } = booking.val().confirmationData;

            const doesDbBookingCodeMatchUrlBookingCode = `${hash}${code}` === queryCode;

            if (doesDbBookingCodeMatchUrlBookingCode) {
                consultCodeVerified = true;
                bookingValue = booking.val();
                // console.log('YAY, we have a match', bookingValue);
            }
        }
    });

    return bookingValue;
}

export const getSessionData = (queryCode, uid, userType) => async dispatch => {
    // console.log(uid, 'IS UID');
    // console.log('USER TYPE', userType, uid);

    // console.log('IF YOU ARE NOT GETTING THE SESSION DATA IT COULD BE THE QUERY BELOW IS NOT WORKING. I coded but couldnt test it out.');
    return new Promise((resolve, reject) => {
        db.ref(`bookings`).orderByChild(userType + 'Uid').equalTo(uid).once('value', allUserBookingsSnap => {
            // console.log('USER TYPE', userType + 'Uid', uid);

            // console.log('BOOKINGS SNAP', allUserBookingsSnap.val());

            const sessionData = verifyAndGetBookingData(allUserBookingsSnap, queryCode);
            // console.log('%cSESSION DATA@VIDEO-ACTION','color: greenyellow');
            // console.log('SESSION DATA:', sessionData);

            dispatch({
                payload: {
                    apiKey: sessionData.apiKey,
                    id: sessionData.sessionId,
                    token: sessionData.token,
                    key: sessionData.key,
                },
                type: types.SESSION_DATA,
            });

            // console.log('GOT SESSION DATA. DISPATCHED TO REDUCER.');
            resolve();

        }, (error) => {
            reject(error);
            console.log('FIREBASE ERROR', error);
        });
    });
}

export const generateTokenFlag = (booking, userId) => dispatch => {
    console.log('GENERATING TOKEN');
    const bookingRef = db.ref(`bookings/${booking.key}`);

    bookingRef.child('generateToken').set('true')
        .then((res) => {
            // console.log('generate TOKEN flag has been set');
        })
        .catch(console.log);

    const bookingTokenRef = bookingRef.child('token');
    bookingTokenRef.off();
    console.log('GETTING TOKEN');

    bookingTokenRef.on('value', snap => {
        const token = snap.val();
        if (token) {
            bookingTokenRef.off();
            console.log('GOT TOKEN', token);

            dispatch({
                payload: token,
                type: types.RECEIVED_TOKEN_SUCCESS,
            });

            // localStorage.setItem('videoToken', token);
        } else if (token === false) {
            console.log('FAILED TO GENERATE TOKEN');

            bookingTokenRef.off();
            dispatch({
                payload: token,
                type: types.RECEIVED_TOKEN_FAIL,
            });
        }
    }, (error) => {
        console.log('FIREBASE ERROR @ GENERATE TOKEN', error);
    });
};

// TOGGLE CONFIRM END CALL ACTION
const shouldDialogBeOpen = (shouldDialogBeOpen) => ({
    type: types.CONFIRM_END_CALL_DIALOG_OPEN,
    payload: shouldDialogBeOpen
});
const shouldNavigateTo = (location = {
    pathname: '/'
}) => ({
    type: types.CONFIRM_END_CALL_NAVIGATION_LOCATION,
    payload: location.pathname
});

export const openConfirmEndCallDialog = (location) => async dispatch => {
    dispatch(shouldNavigateTo(location));
    dispatch(shouldDialogBeOpen(true));
}


export const closeConfirmEndCallDialog = () => shouldDialogBeOpen(false);

const getBooking = (hash) => {
    return new Promise(function (resolve, reject) {
        const bookingCodeRef = db.ref(`bookings`).orderByChild('confirmationData/hash').equalTo(hash);
        bookingCodeRef.once('value', snap => {
            // console.log('booking', snap.val());
            let booking = [];
            snap.forEach(bookingSnap => {
                booking.push(bookingSnap.val())
            })
            resolve(booking[0]);
        }, (error) => {
            console.log('Firebase Error (this is here because I didnt finish the firebase rules for it. It is for the ratings and review functionality after a consult completes and is not even needed with the current functionality. So, you can disregard this error.):', error);
        })
    });
}

const gotOtherUserData = (user) => ({
    type: types.GET_OTHER_VIDEO_USERS_DATA_BY_TYPE_SUCCESS,
    payload: user
})

export const getOtherUsersDataByUserType = ({
    hash,
    isProvider
}) => dispatch => {
    getBooking(hash)
        .then((booking) => {
            if (isProvider === true) {
                console.log('Other User is a client', booking.clientUid);
                const userProfileDataRef = db.ref(`clients/${booking.clientUid}/basicProfile`);
                // get client basic profile Data
                userProfileDataRef.once('value', snap => {
                    const client = {
                        ...snap.val(),
                        uid: booking.clientUid
                    }
                    dispatch(gotOtherUserData(client))
                }, (error) => {
                    console.log('Error in userProfileData FB call', error);
                })
            } else {
                console.log('Other User is a provider', booking.providerUid);
                // Get provider profileData
                db.ref(`providers/${booking.providerUid}`).once('value', snap => {
                    const provider = snap.val();
                    dispatch(gotOtherUserData(provider))
                }, e => console.log)
            }
        })
        .catch(console.log)
}

const gotConsultServiceData = (service) => ({
    type: types.GET_CONSULT_SERVICE_DATA_SUCCESS,
    payload: service
})

export const getConsultServiceData = (hash) => dispatch => {
    getBooking(hash)
        .then((booking) => {
            // Get service data
            console.log('SERVICE ID', booking.serviceKey)
            db.ref(`services/${booking.serviceKey}`).once('value', snap => {
                const service = snap.val();
                console.log('SERVICE', service);
                dispatch(getServiceRatingForUser({
                    serviceId: booking.serviceKey,
                    clientUid: booking.clientUid
                }))
                dispatch(getServiceReviewForUser({
                    serviceId: booking.serviceKey,
                    clientUid: booking.clientUid
                }))

                dispatch(gotConsultServiceData(service))
            }, e => console.log)
        })
        .catch(console.log)
}


// WEBPACK FOOTER //
// ./src/js/actions/video-actions.js